import React from 'react';

import PropTypes from 'prop-types';
import { Map } from 'immutable';

import { Col, Row } from 'react-bootstrap';
import cn from 'classnames';
import CheckoutController from '../../../event_components/Checkout';
import Title from '../../../event_components/title';
import Details from '../../../event_components/details';
import AttendButton from '../../../event_components/attend_button';
import styles from './map.scss';
import EventStatus from '../../../event_components/event_status';
import TicketPurchasing from '../../../event_components/ticket-purchasing';
import AddEventToCalendar from '../../../event_components/add_to_calendar';
import { LocaleWrapper } from '../../../../locale-wrapper';
import Host from '../../../event_components/host';
import TwitchPreviousVideo from '../../../event_components/twitch-video';
import { attendButtonIsVisible } from '../../shared/utils';
import PaginationContainer from '../../shared/pagination_container';
import { EventTime } from '../../../event_components/event-time';
import { EventDate } from '../../../event_components/event-date';
import Gallery from '../../shared/gallery';
import ModalWithProps from '../../../modal';
import { mobileLayoutComponent } from '../../shared/mobileLayoutComponent';
import { Divider } from '@mui/material';
import { MapContainer } from '../../shared/map-container/map-container';
import DateRangeIcon from '@mui/icons-material/DateRange';
import WatchLaterSharpIcon from '@mui/icons-material/WatchLaterSharp';

const propTypes = {
  event: PropTypes.instanceOf(Map).isRequired,
  settings: PropTypes.instanceOf(Map).isRequired,
};

export class ListEvent extends React.Component {
  constructor() {
    super();
    this.state = {
      openTicketing: false,
    };
  }

  toggleAttendButton = () => {
    const { event, onEventRegister } = this.props;

    if (event.get('type') === 'google') {
      return;
    }
    this.props.onResizeComponent();
    this.setState(
      {
        openTicketing: onEventRegister ? false : !this.state.openTicketing,
      },
      () => this.props.onResizeComponent()
    );
    onEventRegister && onEventRegister(event);
  };

  render() {
    const { event, settings, onResizeComponent, forceButtonNewRow } = this.props;
    const logo = event.getIn(['logo', 'url']);

    const hasLogo = settings.get('showEventLogo');
    if (event.get('initial_embed') || event.get('is_offline')) {
      return event.get('is_offline') ? (
        <TwitchPreviousVideo settings={settings} event={event} />
      ) : (
        <TicketPurchasing event={event} settings={settings} open onResizeComponent={onResizeComponent} />
      );
    }

    const xsLogoVisible = logo && hasLogo && event.get('type') !== 'google' && event.get('type') !== 'zoom';

    return (
      <div className={`${styles.container} ${forceButtonNewRow ? styles.center : ''}`}>
        <div className={cn(styles.list, 'event')}>
          <div className={styles.galleryAndMapWrapper}>
            <MapContainer event={event} settings={settings} />
            {xsLogoVisible && <Gallery event={event} />}
          </div>
          <Row style={{ flex: 'auto' }}>
            {event.get('type') === 'zoom' && (
              <Col xs={6} md={4} className={styles.zoomColumn}>
                <Host event={event} settings={settings} />
              </Col>
            )}

            <Row className={styles.details}>
              <div className={cn(styles.item, styles.title)}>
                <Title event={event} settings={settings} />
              </div>
              <Divider orientation="vertical" className="date" />
              <div className={styles.item}>
                <DateRangeIcon alt="date" width="20px" className="date" />
                <EventDate event={event} settings={settings} />
              </div>
              <Divider orientation="vertical" className="date" />
              <div className={styles.item}>
                <WatchLaterSharpIcon alt="time" width="20px" className="date" />
                <EventTime event={event} settings={settings} />
              </div>

              {settings.get('showEventStatus') && (
                <>
                  <Divider orientation="vertical" className="date" />
                  <div className={styles.item}>
                    <EventStatus event={event} settings={settings} />
                  </div>
                </>
              )}
              {settings.get('showEventStatus') && (
                <>
                  <Divider orientation="vertical" className="date" />
                  <div className={styles.item}>
                    <AddEventToCalendar event={event} settings={settings} className={styles.addToCalendar} />
                  </div>
                </>
              )}
            </Row>
            <Details event={event} settings={settings} className={styles.description} onResizeComponent={onResizeComponent} />
          </Row>
          {attendButtonIsVisible(event, settings, this.state.openTicketing) && (
            <AttendButton isFullWidth event={event} className={styles.styledButton} settings={settings} handleButtonClick={this.toggleAttendButton} />
          )}
        </div>
        <CheckoutController
          variant="redesign"
          event={event}
          settings={settings}
          inClassName="checkout-fade"
          openTicketing={this.state.openTicketing}
          onResizeComponent={onResizeComponent}
          onClose={() => {
            this.setState({
              openTicketing: false,
            });
          }}
        />
        <ModalWithProps />
      </div>
    );
  }
}

ListEvent.propTypes = propTypes;

export default function MapLayout({ events, settings, isMobile, onResizeComponent, onEventRegister, forceButtonNewRow }) {
  const Component = isMobile ? mobileLayoutComponent(settings) : ListEvent;

  const renderEvent = (event) => (
    <LocaleWrapper event={event}>
      <Component
        key={event.get('id')}
        event={event}
        settings={settings}
        onResizeComponent={onResizeComponent}
        onEventRegister={onEventRegister}
        forceButtonNewRow={forceButtonNewRow}
      />
    </LocaleWrapper>
  );

  return <PaginationContainer events={events} settings={settings} onResizeComponent={onResizeComponent} renderEvent={renderEvent} />;
}

MapLayout.propTypes = {
  events: PropTypes.instanceOf(Map).isRequired,
  settings: PropTypes.instanceOf(Map).isRequired,
  isMobile: PropTypes.bool,
};
